import { useEffect, useState } from "react";
import { _DocumentFactory, _RequestApprovalBpm, _single } from "../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { PrintJson } from "../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_DATE_DDMMMYYYY, MASK_DATE_YYYYMMDD_HHMM, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { BasicButton } from "../theme/Component/BasicButton";
import { Modal } from "../theme/Component/Modal";
import { DocumentViewer } from "../theme/Component/DocumentViewer";


interface Props {
    data: any;
}
export const SignResume = ({ data }: Props) => {

    const { instance, lista, setLista } = useDataBean(_RequestApprovalBpm);
    const document = useDataBean(_DocumentFactory);
    const modalDocumento = useModal("Documento", MODAL_XL);
    const [listDoc, setListDoc] = useState<any>([]);

    useEffect(() => {
        instance.getRequestApprovalSingRender(data.IDApprovaldocument).then((resp: any) => {
            setLista(resp);
        }).catch(err => toast.error(err))
    }, [data])

    const getDocument = () => {
        document.instance.getPdfAccountantDocument(data.Consecutive, null, data.DocumentDate, _single.getAccountID()).then((resp: any) => {
            if (resp.DocumentURL) {
                setListDoc(resp.DocumentURL);
                modalDocumento.open();

            } else {
                toast.warning("No se encontraron Documentos");
            }
        })
    }

    const head = [
        { title: '#', property: 'IDRequestApprovalBpm', visible: true, mask: MASK_NUMBER },
        { title: 'Orden', property: 'ItemOrder', visible: true },
        { title: 'Firma', property: 'Title', visible: true },
        { title: 'Solicitud', property: 'Mnemonic', visible: true },
        { title: 'Firmante', property: 'EntityName', visible: true },
        { title: 'Solicitado', property: 'Since', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'Observación', property: 'Observation', visible: true },
        { title: 'Fecha', property: 'SingDate', visible: true, mask: MASK_DATE_YYYYMMDD_HHMM },
        { title: 'Estado', property: 'StateName', visible: true }
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicButton icon="ri-file-list-3-line" eventClick={getDocument}>Ver Documento</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={(e) => { }}></BasicTable>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <DocumentViewer list={listDoc} />
                </Modal>

            </div>
        </div>
    )

}